/* VideoLinks cart: dustbin instead of minus at quantity 1, small flip when a quantity changes.
   Cosmetic layer only: the theme still does every cart update itself.
   Dustbin click = clicks the item's own Remove button, so both do exactly the same job.
   To undo: delete the <script> line for vl-cart-qty.js in layout/theme.liquid. */
(function () {
  'use strict';
  if (window.__vlQty) return;
  window.__vlQty = true;

  var TRASH = '<svg class="vl-trash" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<g class="vl-lid"><path d="M4.5 7h15"/><path d="M9.5 7V5.2c0-.7.5-1.2 1.2-1.2h2.6c.7 0 1.2.5 1.2 1.2V7"/></g>' +
    '<path d="M6.5 7.5l.8 10.8c.1 1 .9 1.7 1.9 1.7h5.6c1 0 1.8-.7 1.9-1.7l.8-10.8"/><path d="M10 11v5.5M14 11v5.5"/></svg>';
  var ITEM_SEL = '[id^="MinimogCartDrawer-Item-"],[id^="MinimogCart-Item-"]';
  var lastOne = {};      // item key -> was at quantity 1
  var pending = null;    // { key, dir, t0 } the change we just animated, so a re-render can continue it

  function keyOf(q) {
    var i = q.querySelector('input');
    return (q.closest('m-cart-drawer') ? 'd' : 'p') + (i && i.dataset ? i.dataset.index : '');
  }

  function sync(q, animateSwap) {
    var input = q.querySelector('input'), minus = q.querySelector('button[name="minus"]');
    if (!input || !minus || input.disabled) return;
    if (!minus.querySelector('.vl-trash')) minus.insertAdjacentHTML('beforeend', TRASH);
    var min = parseInt(input.min, 10) || 1;
    var one = parseInt(input.value, 10) <= min;
    q.dataset.vlOne = one ? '1' : '0';
    var k = keyOf(q);
    if (animateSwap && lastOne[k] !== undefined && lastOne[k] !== one) {
      minus.classList.add('vl-swap');
      setTimeout(function () { minus.classList.remove('vl-swap'); }, 360);
    }
    lastOne[k] = one;
  }

  function syncAll(root, animateSwap) {
    (root || document).querySelectorAll('m-quantity-input').forEach(function (q) {
      if (q.closest('[data-minimog-cart-items]')) sync(q, animateSwap);
    });
  }

  function flip(input, dir, delayMs) {
    input.classList.remove('vl-flip-up', 'vl-flip-down');
    void input.offsetWidth;
    input.style.animationDelay = delayMs ? (-delayMs) + 'ms' : '';
    input.classList.add(dir > 0 ? 'vl-flip-up' : 'vl-flip-down');
    input.addEventListener('animationend', function done() {
      input.classList.remove('vl-flip-up', 'vl-flip-down');
      input.style.animationDelay = '';
      input.removeEventListener('animationend', done);
    });
  }

  function removeItem(q) {
    var item = q.closest(ITEM_SEL);
    var rm = item && item.querySelector('m-cart-remove-button');
    if (!rm) return false;
    markRemoving(item);
    rm.click();
    return true;
  }

  function markRemoving(item) {
    if (!item) return;
    item.classList.add('vl-removing');
    setTimeout(function () { item.classList.remove('vl-removing'); }, 4000); // never stay faded if the request fails
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('.m-quantity__button');
    if (b) {
      var q = b.closest('m-quantity-input');
      if (!q || !q.closest('[data-minimog-cart-items]')) return;
      var input = q.querySelector('input');
      if (b.name === 'minus' && q.dataset.vlOne === '1') {
        if (removeItem(q)) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }
        return;
      }
      var before = input.value, dir = b.name === 'plus' ? 1 : -1;
      setTimeout(function () {
        if (input.value === before) return;
        sync(q, true);
        flip(input, dir, 0);
        pending = { key: keyOf(q), dir: dir, t0: performance.now() };
      }, 0);
      return;
    }
    var r = t.closest('m-cart-remove-button');
    if (r) markRemoving(r.closest(ITEM_SEL));
  }, true);

  // typing a number directly
  document.addEventListener('change', function (e) {
    var q = e.target && e.target.closest && e.target.closest('m-quantity-input');
    if (q && q.closest('[data-minimog-cart-items]')) sync(q, true);
  }, true);

  // the theme swaps the items' HTML after every change: re-apply the icon and carry the flip over
  function onRender(box) {
    syncAll(box, true);
    if (pending) {
      var p = pending, elapsed = performance.now() - p.t0;
      pending = null;
      if (elapsed < 280) {
        box.querySelectorAll('m-quantity-input').forEach(function (q) {
          if (keyOf(q) === p.key) { var i = q.querySelector('input'); if (i && i.offsetParent !== null) flip(i, p.dir, elapsed); }
        });
      }
    }
  }

  var scheduled = false;
  function watch() {
    document.querySelectorAll('[data-minimog-cart-items]').forEach(function (box) {
      if (box.__vlWatched) return;
      box.__vlWatched = true;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () { scheduled = false; onRender(box); });
      }).observe(box, { childList: true, subtree: true });
      syncAll(box, false);
    });
  }

  function init() { try { watch(); } catch (err) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* v75: Viral Right Now slider - realign Swiper when its computed slide width differs from the CSS width, so the first video starts fully visible */
(function(){
  function fixAll(){
    document.querySelectorAll('.m-mixed-layout__wrapper.swiper-container').forEach(function(c){
      try{
        var s=c.swiper;if(!s||s.__vlfix||typeof s.params.slidesPerView!=='number')return;
        var sl=c.querySelector('.swiper-slide:not(.swiper-slide-duplicate)');if(!sl)return;
        var spv=s.params.slidesPerView,gap=s.params.spaceBetween||0;
        var expect=(s.width-gap*(spv-1))/spv,real=sl.getBoundingClientRect().width;
        if(real>0&&Math.abs(real-expect)>4){
          s.__vlfix=1;s.params.slidesPerView='auto';s.params.slidesPerGroup=1;
          if(s.params.loop){s.loopDestroy();s.loopCreate();}
          s.update();
          if(s.slideToLoop)s.slideToLoop(0,0,false);else s.slideTo(0,0,false);
        }
      }catch(e){}
    });
  }
  function run(){setTimeout(fixAll,1200);setTimeout(fixAll,3000);setTimeout(fixAll,6000)}
  if(document.readyState==='complete')run();else window.addEventListener('load',run);
})();

/* v79: inline header search - the header pill is a real input; results drop down right under it (no second search box) */
(function(){
  if(window.__vlSearch)return;window.__vlSearch=1;
  var html=document.documentElement,pills=[],cur=null,timer=null,hints=null,activeIdx=-1;
  var ICON_X='<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function ps(){return document.querySelector('predictive-search')}
  function popup(){return document.querySelector('[data-search-popup]')}
  function visible(el){return el&&el.getBoundingClientRect().width>0}
  function searchUrl(q){return '/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&q='+encodeURIComponent(q)}
  function place(){
    if(!cur)return;
    var r=cur.pill.getBoundingClientRect(),hd=document.querySelector('.m-header__wrapper')||document.querySelector('header'),hb=hd?hd.getBoundingClientRect().bottom:r.bottom;
    var phone=window.innerWidth<768,vv=window.visualViewport,vh=vv?vv.height:window.innerHeight;
    var top=Math.round(r.bottom+8);
    html.style.setProperty('--vl-sp-top',top+'px');
    html.style.setProperty('--vl-sp-hdr',Math.max(0,Math.round(hb))+'px');
    html.style.setProperty('--vl-sp-left',(phone?10:Math.round(r.left))+'px');
    html.style.setProperty('--vl-sp-w',(phone?window.innerWidth-20:Math.round(r.width))+'px');
    html.style.setProperty('--vl-sp-maxh',Math.max(160,Math.round(vh-top-12))+'px');
  }
  function open(p){
    cur=p;place();html.classList.add('vl-search-on','prevent-scroll');
    var q=p.input.value.trim();html.classList.toggle('vl-has-q',!!q);
    if(q)run(p);
  }
  function close(keepFocus){
    html.classList.remove('vl-search-on','vl-has-q','prevent-scroll');
    var s=ps();if(s&&s.close)try{s.close()}catch(e){}
    activeIdx=-1;
    if(cur&&!keepFocus)cur.input.blur();
    cur=null;
  }
  function run(p){
    var s=ps();if(!s)return;
    var q=p.input.value.trim();
    html.classList.toggle('vl-has-q',!!q);
    if(!q){try{s.close(true)}catch(e){}return}
    s.input.value=p.input.value;
    try{s.onChange()}catch(e){}
    activeIdx=-1;
  }
  function items(){var pop=popup();return pop?[].slice.call(pop.querySelectorAll('.m-search-item')):[]}
  function setActive(i){var it=items();it.forEach(function(e){e.classList.remove('vl-active')});if(!it.length){activeIdx=-1;return}
    activeIdx=(i+it.length)%it.length;it[activeIdx].classList.add('vl-active');it[activeIdx].scrollIntoView({block:'nearest'})}
  function build(el){
    if(el.__vl)return;el.__vl=1;el.removeAttribute('data-open-search-popup');el.classList.add('vl-sp');
    var input=document.createElement('input');input.type='search';input.className='vl-sp-input';input.placeholder='Search products';
    input.setAttribute('autocomplete','off');input.setAttribute('autocorrect','off');input.setAttribute('autocapitalize','off');input.setAttribute('spellcheck','false');
    input.setAttribute('enterkeyhint','search');input.setAttribute('aria-label','Search products');input.name='vlq';
    var clr=document.createElement('button');clr.type='button';clr.className='vl-sp-clear';clr.setAttribute('aria-label','Clear search');clr.innerHTML=ICON_X;
    el.appendChild(input);el.appendChild(clr);
    if(el.closest('.m-header__mobile')&&el.parentNode){var cn=document.createElement('button');cn.type='button';cn.className='vl-sp-cancel';cn.textContent='Cancel';
      cn.addEventListener('click',function(){input.value='';clr.style.display='none';close()});el.parentNode.insertBefore(cn,el.nextSibling)}
    var p={pill:el,input:input,clear:clr};pills.push(p);
    input.addEventListener('focus',function(){open(p)});
    input.addEventListener('input',function(){
      clr.style.display=input.value?'flex':'none';
      html.classList.toggle('vl-has-q',!!input.value.trim());
      clearTimeout(timer);timer=setTimeout(function(){run(p)},110);
    });
    input.addEventListener('keydown',function(e){
      if(e.key==='Escape'){close();return}
      if(e.key==='ArrowDown'){e.preventDefault();setActive(activeIdx+1);return}
      if(e.key==='ArrowUp'){e.preventDefault();setActive(activeIdx-1);return}
      if(e.key==='Enter'){
        var it=items();if(activeIdx>-1&&it[activeIdx]){window.location.href=it[activeIdx].href;return}
        var q=input.value.trim();if(q){e.preventDefault();window.location.href=searchUrl(q)}
      }
    });
    clr.addEventListener('mousedown',function(e){e.preventDefault()});
    clr.addEventListener('click',function(){input.value='';clr.style.display='none';run(p);input.focus()});
    el.addEventListener('click',function(e){
      if(e.target===input||clr.contains(e.target))return;
      var btn=e.target.closest&&e.target.closest('.m-search-form__button');
      if(btn&&input.value.trim()){window.location.href=searchUrl(input.value.trim());return}
      input.focus();
    });
  }
  function buildHints(){
    var pop=popup();if(!pop||hints)return;
    hints=document.createElement('div');hints.className='vl-sp-hints';
    var names=['Peak Design','Godox','Haida','DJI','PolarPro','TTArtisan','Dry cabinet','Microphone'];
    hints.innerHTML='<p class="vl-sp-hints__t">Popular searches</p><div class="vl-sp-hints__row">'+names.map(function(n){return '<a href="'+searchUrl(n)+'">'+n+'</a>'}).join('')+'</div>';
    pop.appendChild(hints);
  }
  function init(){
    document.querySelectorAll('m-search-popup.m-header__search').forEach(build);
    buildHints();
    var pop=popup();
    if(pop&&!pop.__vl){pop.__vl=1;
      pop.addEventListener('click',function(e){if(e.target===pop){e.stopPropagation();e.preventDefault();close()}},true);
    }
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('[data-open-search-popup]');
    if(!t||!pills.length)return;
    e.preventDefault();e.stopPropagation();
    var p=pills.filter(function(x){return visible(x.pill)})[0]||pills[0];window.scrollTo(0,0);p.input.focus();
  },true);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&cur)close()});
  window.addEventListener('resize',place);
  if(window.visualViewport)window.visualViewport.addEventListener('resize',place);
  window.addEventListener('pageshow',function(){if(cur)close(true)});
  if(typeof MinimogEvents!=='undefined'&&window.MinimogTheme&&MinimogTheme.pubSubEvents)try{MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer,function(){if(cur)close()})}catch(e){}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  setTimeout(init,500);setTimeout(init,1800);
})();

/* v84: All brands page - hero card, live "Find a brand" filter */
(function(){
  function init(){
    var w=document.querySelector('.m-collection-list-template__wrapper'),h=document.querySelector('.m-page-header--template-list-collections .container-fluid');
    if(!w||!h||w.__vl)return;w.__vl=1;
    var cols=[].slice.call(w.children).filter(function(e){return e.querySelector('.m-collection-card')});
    var card=document.createElement('div');card.className='vl-lc-card';
    while(h.firstChild)card.appendChild(h.firstChild);
    var meta=document.createElement('div');meta.className='vl-lc-meta';
    meta.innerHTML='<span class="vl-lc-count">'+cols.length+' brands</span><p>Authorised dealer for every brand we stock. Pick a brand to see its full range.</p>';
    card.appendChild(meta);h.appendChild(card);
    var box=document.createElement('div');box.className='vl-lc-find';
    box.innerHTML='<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg><input type="search" name="vlb" placeholder="Find a brand" aria-label="Find a brand" autocomplete="off" autocorrect="off" spellcheck="false" enterkeyhint="go"><button type="button" aria-label="Clear" hidden><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    w.parentNode.insertBefore(box,w);
    var empty=document.createElement('p');empty.className='vl-lc-empty';empty.hidden=true;empty.textContent='No brand matches that name. Try fewer letters.';
    w.parentNode.appendChild(empty);
    var input=box.querySelector('input'),clr=box.querySelector('button');
    var names=cols.map(function(c){var a=c.querySelector('.m-collection-card__link');return (a?a.textContent:'').trim().toLowerCase()});
    function filter(){
      var q=input.value.trim().toLowerCase(),shown=0,last=null;
      cols.forEach(function(c,i){var ok=!q||names[i].indexOf(q)>-1;c.classList.toggle('vl-lc-off',!ok);if(ok){shown++;last=c}});
      clr.hidden=!input.value;empty.hidden=shown>0;w.__one=(shown===1)?last:null;
    }
    input.addEventListener('input',filter);
    input.addEventListener('keydown',function(e){if(e.key==='Enter'){var l=w.__one&&w.__one.querySelector('a[href]');if(l){window.location.href=l.href}else input.blur()}});
    clr.addEventListener('click',function(){input.value='';filter();input.focus()});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  setTimeout(init,600);
})();

/* v84: cart page - item count chip next to the title */
(function(){
  function upd(){
    var h=document.querySelector('.template-cart .m-page-header__title');if(!h)return;
    var q=0;document.querySelectorAll('.template-cart m-cart .m-cart-item [data-cart-quantity]').forEach(function(i){q+=parseInt(i.value,10)||0});
    h.setAttribute('data-vl-count',q?(q+(q===1?' item':' items')):'');
  }
  function init(){
    var body=document.querySelector('.template-cart m-cart');if(!body||body.__vlc)return;body.__vlc=1;
    upd();new MutationObserver(function(){upd()}).observe(body,{childList:true,subtree:true,attributes:true,attributeFilter:['value']});
    body.addEventListener('change',upd);body.addEventListener('input',upd);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  setTimeout(init,800);
})();
